import { HttpClient } from '@sphere/shared/data-access/http'
import type {
  ActivityKind,
  ActivityStateRef,
  AttemptStatusRef,
} from '@sphere/learning/domain'

export const referencesClient = {
  activityKinds: () =>
    HttpClient.get<ActivityKind[]>('/learning/activity-kinds'),

  activityStates: () =>
    HttpClient.get<ActivityStateRef[]>('/learning/referentials/states'),

  attemptStatuses: () =>
    HttpClient.get<AttemptStatusRef[]>('/learning/attempt-statuses'),
}
